import React from "react";
import {Box, Button, Typography} from "@mui/material";
import HouseImage from "../assets/images/404Image.png";
import {useNavigate} from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <article
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{display: "flex", flexDirection: "column", alignItems: "center", margin: "16px"}}>
        <Typography variant="h2" fontWeight={700} paddingBottom={4}>
          404 ERROR
        </Typography>
        <Typography variant="h5" paddingBottom={2}>
          죄송합니다. 페이지를 찾을 수 없습니다.
        </Typography>
        <Typography>
          존재하지 않은 주소를 입력하셨거나, 요청하신 페이지의 주소가 변경, 삭제되었을 수 있습니다.
        </Typography>
        <Typography>입력하신 주소가 정확한지 다시 한번 확인해주세요.</Typography>
        <img src={HouseImage} alt="" width="400px" height="auto" />
        <Button
          variant="outlined"
          sx={{fontSize: "16px", fontWeight: 500}}
          onClick={() => {
            navigate(`/Home/DashBoard`);
          }}
        >
          홈으로
        </Button>
      </div>
    </article>
  );
};

export default NotFound;
